<template>
	<div class="main">
		<el-row>
			<el-col :span="24" style="font-size: 16px;">
				<div>基本信息</div>
			</el-col>
		</el-row>
		<div class="contain">
			<div class="person-right">
				<el-row>
					<el-col :span="24" style="font-size: 20px;">
						<div>{{oldFileData.elderName}}</div>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<div>
							<span>性别：</span>
							<span>{{oldFileData.sexDictId}}</span>
						</div>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<div>
							<span>年龄：</span>
							<span>{{oldFileData.age}}</span>
						</div>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<div>
							<span>联系方式：</span>
							<span>{{oldFileData.phone}}</span>
						</div>
					</el-col>
				</el-row>
			</div>
			<div class="person-left">
				<el-row class="left-f">
					<el-col :span="8">
						<div>身高</div>
						<div>{{oldFileData.height}}</div>
					</el-col>
					<el-col :span="8">
						<div>体重</div>
						<div>{{oldFileData.wight}}</div>
					</el-col>
					<el-col :span="8">
						<div>血糖</div>
						<div>{{oldFileData.sugarValue}}</div>
					</el-col>
				</el-row>
				<el-row class="left-s">
					<el-col :span="8">
						<div>血氧</div>
						<div>{{oldFileData.oxygenValue}}</div>
					</el-col>
					<el-col :span="8">
						<div>血压</div>
						<div>{{oldFileData.pressureValue}}</div>
					</el-col>
					<el-col :span="8">
						<div>心率</div>
						<div>{{oldFileData.heartRate}}</div>
					</el-col>
				</el-row>
			</div>
		</div>
		<div>
			<el-row style="padding: 20px 0;">
				<el-col :span="24" style="font-size: 16px;">
					<div>老人服务记录</div>
				</el-col>
			</el-row>
			<template>
				<el-table  v-loading="list_loading" :data="oldFileList" border style="width: 100%">
					<el-table-column prop="time" label="检测时间">
					</el-table-column>
					<el-table-column prop="type" label="检测项目">
					</el-table-column>
					<el-table-column prop="result" label="检测结果">
					</el-table-column>
					<el-table-column prop="collectType" label="来源采集方式">
					</el-table-column>
					<el-table-column prop="deviceSid" label="设备串号">
					</el-table-column>
				</el-table>
			</template>
		</div>
		<div class="block">
			<el-pagination @current-change="handleCurrentChange" :current-page="currentPage" background @size-change="handleSizeChange" :page-sizes='[5,10,20]' :page-size='pageSize' layout="sizes,prev, pager, next,total,jumper" :total="total">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				total: 0, //总页数
				pageSize: 5, //每页条数
				currentPage: 1, //当前页（默认第一页）
				oldFileData:[],
				oldFileList: [{
					date: '2016-05-02',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1518 弄'
				}],
				list_loading:true
			};
		},
		created() {
			this.getOldFile()
			this.getOldFileList()
		},
		methods: {
			handleCurrentChange(val) {
				this.currentPage = val; //获取当前页
				this.getOldFileList();
			},
			handleSizeChange(psize) { //选择每页条数
				this.pageSize = psize;
				this.getOldFileList();
			},
			getOldFile() {
				this.$post("api/nurseElderly/detail/"+ this.$route.query.id).then(res=>{
					window.console.log(res)
					this.oldFileData = res.data
				}).catch((e) => {window.console.log(e)})
				
			},
			getOldFileList() {
				const data={
					elderId: this.$route.query.id,
					length: this.pageSize,
					start: (this.currentPage - 1) * this.pageSize
				}
				this.$get("api/nurseElderly/service/list",data).then(res => {
					this.oldFileList = res.data
					this.total = res.recordsFiltered
					this.list_loading=false
					this.oldFileList.map(function(val) {
						switch(val.collectType){//采集方式
							case 1:
							val.collectType = "APP";
							break;
							case 2:
							val.collectType = "微信";
							break;
							case 3:
							val.collectType = "会员网站端";
							break;
						}
					})
					this.oldFileList.map(function(val) {//监测类别
						switch(val.type){
							case 1:
							val.type = "血压";
							break;
							case 2:
							val.type = "血糖";
							break;
							case 3:
							val.type = "体重";
							break;
							case 4:
							val.type = "运动";
							break;
							case 5:
							val.type = "睡眠";
							break;
							case 6:
							val.type = "身体指数";
							break;
							case 7:
							val.type = "血脂";
							break;
							case 8:
							val.type = "血尿酸";
							break;
							case 9:
							val.type = "血氧";
							break;
							case 10:
							val.type = "心电";
							break;
							case 11:
							val.type = "呼吸率";
							break;
							case 12:
							val.type = "精神指数";
							break;
							case 13:
							val.type = "皮肤指数";
							break;
							case 14:
							val.type = "体温";
							break;
							case 15:
							val.type = "健康护理床位";
							break;
						}
					})
				})
			},
			

		},
	}
</script>

<style scoped="scoped">
	.main{
		background: #fff;
		padding:20px;
	}
	.main .block {
		text-align: center;
		margin-top: 20px;
	}

	.contain {
		display: flex;
		padding: 0 0 10px 0;
		border-bottom: 1px solid #ccc;
	}

	.person-right {
		padding: 20px 0;
		width: 36vw;
		font-size: 14px;
		box-sizing: border-box;

	}

	.person-right .el-row .el-col div {
		padding: 3px 0;
	}

	.person-left {
		width: 54vw;
		box-sizing: border-box;
	}

	.person-left .left-f .el-col:first-of-type {
		background: #03152A;
	}

	.person-left .left-f .el-col:nth-of-type(2) {
		background: linear-gradient(top right, #03152A, #0b2b51);
	}

	.person-left .left-f .el-col:nth-of-type(3) {
		background: linear-gradient(top right, #03152A, #0b2b51);
	}

	.person-left .left-s .el-col:first-of-type {
		background: #0b2b51;
	}

	.person-left .left-s .el-col:nth-of-type(2) {
		background: linear-gradient(top left, #03152A, #0b2b51);
	}

	.person-left .left-s .el-col:nth-of-type(3) {
		background: #03152A;
		/*渐变从左上角到右下角*/
	}

	.person-left .el-row .el-col {
		height: 106px;
		color: #fff;
	}

	.person-left .el-row .el-col div:first-of-type {
		padding: 10px 30px;
		font-size: 14px;

	}

	.person-left .el-row .el-col div:nth-of-type(2) {
		padding: 10px 30px;
		font-size: 20px;
		text-align: right;
	}
</style>
